import React, { useEffect, useState } from "react";
import {
  CarbonPlan,
  DeviceMeetingRemoteIcon,
  QuickActionBoxVector,
  RoundAddIcon,
} from "../common/Icon";
import SetDailyPlanModal from "./SetDailyPlanModal";

import LogChatProfileModal from "./LogChatProfileModal";
import { useStateProvider } from "../common/StateProvider";

const QuickActions = () => {
  const [dailyPlanModal, setDailyPlanModal] = useState(false); //Set Daily Plan Modal
  const { logChatModal, setLogChatModal } = useStateProvider();

  // OVERLAY BEHIND FILTER MODEL
  // const overLayHidden = () => {
  //   setDailyPlanModal(false);
  //   setLogChatModal(false);
  // };
  // OVERFLOW HIDDEN WHEN FILTER MODEL OPEN
  useEffect(() => {
    if (dailyPlanModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [dailyPlanModal]);
  return (
    <>
      <div className=" relative  rounded-2xl border-[1.393px] border-solid border-[rgba(111,_106,_248,_0.10)] bg-white shadow-[0px_8.36066px_19.5082px_0px_rgba(75,_87,_239,_0.03),_0px_-2.78689px_19.5082px_0px_rgba(75,_87,_239,_0.10)] w-[255px]">
        <button
          onClick={() => setDailyPlanModal(true)}
          className="text-sm 3xl:text-[16px] text-black/70 font-normal hover:bg-black/10 rounded-t-2xl duration-200  py-2.5 pl-4 border-b-[1.393px] border-solid border-[#F2F2F2] flex items-center w-full">
          <span className="bg-primary rounded-full p-[6px] mr-3">
            <CarbonPlan />
          </span>
          Set Daily Plan
        </button>
        <button
          onClick={() => setDailyPlanModal(true)}
          className="text-sm 3xl:text-[16px] text-black/70 font-normal hover:bg-black/10 duration-200  py-2.5 pl-4 border-b-[1.393px] border-solid border-[#F2F2F2] flex items-center w-full">
          <span className="bg-primary rounded-full p-[6px] mr-3">
            <span>
              <RoundAddIcon />
            </span>
          </span>
          Schedule
        </button>
        <button
          onClick={() => setLogChatModal(true)}
          className="text-sm 3xl:text-[16px] text-black/70 font-normal hover:bg-black/10 rounded-b-2xl duration-200 z-50 relative  py-2.5 pl-4 flex items-center w-full">
          <span className="bg-primary rounded-full p-[6px] mr-3">
            <DeviceMeetingRemoteIcon />
          </span>
          Log Chat
        </button>
      </div>
      <span className="absolute bottom-[-20px] right-[10px] block ">
        <QuickActionBoxVector />
      </span>
      <div className="absolute top-[-20px] z-[51]">
        {dailyPlanModal && <SetDailyPlanModal />}
      </div>
      <div className="absolute top-[-220px] right-[-18px] xs:right-[-18px] xm:right-0 z-[999999999999999]">
        {logChatModal && <LogChatProfileModal />}
      </div>
    </>
  );
};

export default QuickActions;
